"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleValues = handleValues;
exports.handleDefaultValues = handleDefaultValues;
var RAW_SSN_LENGTH = 9;
/**
 * Converts a formatted SSN to just the raw input values
 * ie: `123 - 45 - 6789` becomes `123456789`
 */

function unformatSSN(ssn) {
  if (ssn === '') return ssn;
  var separator = /\s*-\s*/;
  return ssn.split(separator).join('');
}
/**
 * Converts a raw SSN to formatted with spaces and hyphens
 * ie: `123456789` becomes `123 - 45 - 6789`
 */


function formatSSN(ssn) {
  if (ssn === '') return ssn;
  var pattern = '*********'; // Append required number of * to make SSN 9 characters long

  var mergedStr = ssn.concat(pattern.substring(0, pattern.length - ssn.length)); // Then apply the regex to format it with separator: ' - '

  var formattedSSN = mergedStr.replace(/([*0-9]{3})([*0-9]{2})([*0-9]{4})/, '$1 - $2 - $3'); // Remove the * after formatting

  return formattedSSN.substring(0, formattedSSN.indexOf('*')) || formattedSSN;
}
/**
 * Converts a formatted SSN to formatted masked SSN
 * ie: `123 - 45 - 6789` becomes `••• - •• - ••••`
 */


function maskSSN(ssn) {
  if (ssn === '') return ssn;
  return ssn.replace(/[0-9]/g, '•');
}
/**
 * Computes the next mask value to add to our data model
 */


function getNextValueFromMaskedValue(value, rawValue, formattedValue) {
  // Handles the odd case where an extra bullet is added in a masked state
  if (rawValue.length >= RAW_SSN_LENGTH && unformatSSN(value).length === RAW_SSN_LENGTH) {
    return rawValue;
  }

  var unformattedValue = unformatSSN(value);
  /**
   * Deletion Case: formatted masked input < stored formatted unmasked input (contains hyphens, spaces)
   * We update `value` with `rawValue` by removing the correct amount of characters from `rawValue`,
   * and using that value to update next state
   */

  if (value.length < formattedValue.length) {
    var deleteDiffLength = rawValue.length - unformattedValue.length || 1;
    return rawValue.substring(0, rawValue.length - deleteDiffLength);
  }
  /**
   * Addition Case: formatted masked input > stored formatted unmasked input (contains hyphens, spaces)
   * We update `value` with `rawValue` by adding the correct amount of characters from `rawValue`,
   * and using that value to update next state
   */


  var additionDiffLength = unformattedValue.length - rawValue.length;
  var lastDigits = unformattedValue.substring(unformattedValue.length - additionDiffLength, unformattedValue.length);
  return rawValue + lastDigits;
}
/**
 * Main function to format SSN values
 */


function handleValues(prevState, nextValue) {
  var value = nextValue;
  var isMasked = prevState.isMasked,
      rawValue = prevState.rawValue,
      formattedValue = prevState.formattedValue; // Masked input handler

  if (isMasked) {
    value = getNextValueFromMaskedValue(value, rawValue, formattedValue);
  } // Replace all hyphens


  value = value.replace(/-/g, ''); // Replace all spaces, bullets

  value = value.replace(/ +/g, '').replace(/\u2022/g, ''); // Replace any characters that are not either a number or a space with a dash

  var normalized = value.replace(/[^0-9\s-]+/g, '');
  var formatted = formatSSN(normalized);
  return {
    rawValue: normalized,
    formattedValue: formatted,
    maskedValue: maskSSN(formatted)
  };
}
/**
 * Main function to format default SSN values
 */


function handleDefaultValues(defaultValue) {
  if (!defaultValue) {
    return {
      rawValue: '',
      formattedValue: '',
      maskedValue: ''
    };
  }

  var value = defaultValue; // Replace all hyphens

  value = value.replace(/-/g, ''); // Replace all spaces, bullets

  value = value.replace(/ +/g, '').replace(/\u2022/g, ''); // Replace any characters that are not either a number or a space with a dash

  var normalized = value.replace(/[^0-9\s-]+/g, '');
  var formatted = formatSSN(normalized);
  return {
    rawValue: normalized,
    formattedValue: formatted,
    maskedValue: maskSSN(formatted)
  };
}
